import Icon from '@components/Icon';
import Page from '@components/PageAuth';
import AppContext from '@services/Context';
import { Routes } from '@src/helpers/_routes';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Form, Input, Row } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import { LocalStorageKeys } from './App';

export interface ILoginContainerProps {
  form: any;
}


interface ILoginContainerState {
  passwordHidden: boolean;
  onLogin?: Function;
  username: string;
  password: string;
}

const FormItem = Form.Item;
export default class Login extends React.Component<ILoginContainerProps, ILoginContainerState> {


  constructor(props: ILoginContainerProps) {
    super(props);

    this.state = {
      passwordHidden: true,
      username: localStorage.getItem(LocalStorageKeys.USER_NAME) || '',
      password: '',
    }

    this.togglePasswordVisible = this.togglePasswordVisible.bind(this);
    this.onLoginSubmit = this.onLoginSubmit.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onUsernameChange = this.onUsernameChange.bind(this);
    this.checkSubmitButtonDisabled = this.checkSubmitButtonDisabled.bind(this);
  }

  togglePasswordVisible() {
    this.setState({ passwordHidden: !this.state.passwordHidden });
  }

  async onUsernameChange(e: any) {
    this.setState({ username: (e.target.value).toLowerCase() });
  }

  async onPasswordChange(e: any) {
    this.setState({ password: e.target.value });
  }

  onLoginSubmit = (appLogin: any) => async (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        localStorage.setItem(LocalStorageKeys.USER_NAME, this.state.username);
        appLogin(this.state.username, this.state.password)
      }
    });
  }

  checkSubmitButtonDisabled() {
    return !this.state.username || this.state.username.length === 0 || !this.state.password || this.state.password.length === 0;
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Page>
        <AppContext.Consumer>
          {({ Login, authorized, isLoggingIn, client }) => {
            return (
              <Content>
                <div className="login">
                  <div className="title-wrapper">
                    <Row>
                      <h1>{I18n.l('titles.login')}</h1>
                    </Row>
                  </div>
                  <div className={"inputs-container"}>
                    <Form onSubmit={this.onLoginSubmit(Login)} hideRequiredMark={true} >
                      {/* Username */}
                      <FormItem
                        label={I18n.l('form.labels.usernameOrEmail')}
                        colon={false}
                      >
                        {getFieldDecorator('username', {
                          initialValue: this.state.username,
                          rules: [
                            {
                              required: true,
                              message: I18n.l('common.fieldRequired')
                            }],
                        })(
                          <Input
                            disabled={isLoggingIn}
                            onChange={e => this.onUsernameChange(e)}
                          />
                        )}
                      </FormItem>

                      {/* PASSWORD */}

                      <FormItem
                        label={I18n.l('form.labels.password')}
                        colon={false}
                      >
                        <div className="password-wrapper" >
                          {getFieldDecorator('password', {
                            initialValue: this.state.password,
                            rules: [{
                              required: true,
                              message: I18n.l('common.fieldRequired')
                            }],
                          })(
                            <Input
                              type={this.state.passwordHidden ? "password" : "text"}
                              disabled={isLoggingIn}
                              onChange={e => this.onPasswordChange(e)}
                              suffix={
                                <div className="icon-wrapper" onClick={this.togglePasswordVisible}>
                                  <Icon name={this.state.passwordHidden ? "eye-slash" : "eye"} />
                                </div>
                              }
                            />
                          )}
                        </div>
                      </FormItem>


                      <div className="login-btn-wrapper">
                        <Button
                          type="primary"
                          size="large"
                          // onClick={() => this.onLoginSubmit(Login)}
                          // disabled={this.checkSubmitButtonDisabled()}
                          loading={isLoggingIn}
                          htmlType="submit"
                          block
                        >
                          {I18n.l('common.login')}
                        </Button>
                      </div>
                      <div className={"forget-password-container"}>
                        <Link to={isLoggingIn ? '' : `${Routes.recover}`}>
                          <Button
                            type='primary'
                            size="large"
                            block
                            ghost
                          >
                            {I18n.l('common.recoverPassword')}
                          </Button>
                        </Link>
                      </div>
                    </Form>
                  </div>
                </div>
              </Content>
            );
          }}
        </AppContext.Consumer>
      </Page>
    );
  }
}

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 50px;
    width: -webkit-fill-available;
            
    .login{
        width: inherit;
        .form-actions-wrapper {
            text-align: left;
        }
                
        .link-recover {
            display: block;
            color: red;
            font-size: 12px;
            margin: 10px 0;
            text-decoration: underline;
        }

        .title-wrapper{
            margin-top: 30px;
            h1{
                font-size: 44px;
                font-weight: bolder;
            }
        }
        .inputs-container{
            margin-top: 40px;
            
            .ant-form-item-label label{
                color: ${Theme.secondary.midGrey}; 
                font-weight: 700;
                text-transform: uppercase;
            }

            .password-wrapper{
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
            }
            .icon-wrapper{
                cursor: pointer;
                margin-left: 10px;
            }
            .login-btn-wrapper{
                display: flex;
                justify-content: flex-end;
                        
                > button{
                    text-transform: uppercase;
                    font-weight: bold;
                }
                .ant-btn {
                  color: #FFFFFF;
                  background-color: #335D7C;
                  border-radius: 30px;
              }
            }

            .forget-password-container{
                margin-top: 1rem;
                .ant-btn {
                  color: #335D7C;
                  background-color:#FFFFFF;
                  border-radius: 30px;
                  text-transform: uppercase;
                  font-weight: bold;
              }
            }
        }
    }
 `;

export const WrappedLoginContainer = Form.create()(Login);